export default "__VITE_ASSET__DM8n6dVP__"